import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getResidenceInformationStart,
  getResidenceInformationSuccess,
  getResidenceInformationFailed,
} from "../redux/getResidenceInformation";

import { getResidenceInformationApi } from "core/http/service/personnelInformation";
import { resetFormEditResidenceInformation } from "../redux/formEditResidenceInformation";

function* getResidenceInformationWork() {
  try {
    const res = yield call(getResidenceInformationApi);

    yield put({
      type: getResidenceInformationSuccess.type,
      payload: res,
    });

    yield put({
      type: resetFormEditResidenceInformation.type,
    });
  } catch (error: any) {
    yield put({
      type: getResidenceInformationFailed.type,
    });
  }
}

function* watchGetResidenceInformation() {
  yield takeLatest(
    getResidenceInformationStart.type,
    getResidenceInformationWork
  );
}

export default function* getResidenceInformationSaga() {
  yield all([watchGetResidenceInformation()]);
}
